const PREFIX = "neulytics";

export function mark(name: string): void {
  if (typeof performance === "undefined") return;
  performance.mark(`${PREFIX}:${name}`);
}

export function measure(name: string, start: number): void {
  if (typeof performance === "undefined") return;
  performance.measure(`${PREFIX}:${name}`, { start, end: performance.now() });
}

export async function timedImport<T>(
  name: string,
  load: () => Promise<T>,
): Promise<T> {
  const start = performance.now();
  try {
    return await load();
  } finally {
    measure(`route-chunk:${name}`, start);
  }
}
